package com.trevorwiebe.timesheet.admin.locations.presentation

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog

@Composable
actual fun AddEditLocationDialog(
    form: LocationFormState,
    isEditing: Boolean,
    isDeleted: Boolean,
    isGeocoding: Boolean,
    geocodeError: String?,
    onEvent: (LocationsEvent) -> Unit
) {
    Dialog(onDismissRequest = { onEvent(LocationsEvent.OnDismissDialog) }) {
        Card(shape = RoundedCornerShape(16.dp)) {
            Column(modifier = Modifier.padding(vertical = 16.dp)) {
                AddEditLocationFormContent(
                    form = form,
                    isEditing = isEditing,
                    isDeleted = isDeleted,
                    isGeocoding = isGeocoding,
                    geocodeError = geocodeError,
                    onEvent = onEvent
                )
            }
        }
    }
}
